import React, { FC, useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from '../../../store'
import CustomPopup from '../../UI/Popup'
import GeneralForm from '../../Form'
import Checkbox from '../../UI/Inputs/Checkbox'
import { FormikHelpers } from 'formik'
import CustomButton from '../../UI/Buttons/CustomButton'
import { TSkipApprovalFormValues } from '../../../models/form'
import { APPROVAL_TYPE, POST_SOCIAL_STATUS, POST_STATUS } from '../../../models/post'
import {
  toggleIsSkipAprrovalModalAction,
  resetSkipApprovalAction,
  openApproverModalAction,
  updateSkipApproverAction
} from '../../../store/modal/skipApprovalPost/slice'
import { toggleIsOpenAprrovalModalAction } from '../../../store/modal/approvalPost/slice'
import { skipApprovalPostsThunk, skipApprovalPostsSocialThunk } from '../../../store/modal/skipApprovalPost/thunks'
import { isFulfilled } from '@reduxjs/toolkit'
import {
  updatePostSocialsThunk,
  savePostAsDraftAndScheduleThunk
} from '../../../store/managePost/thunks'
import { updateSkipApprovalAction } from '../../../store/managePost/slice'
import { generatePath, useParams } from 'react-router'
import { goBack, push } from 'connected-react-router'
import { AUTH_ROUTE } from '../../../pages/App/routes'
import Roles from '../../../models/roles'
import { getProjectUsersByRoleThunk } from '../../../store/project/thunks'

import './SkipApprovalModal.scss'

interface SkipApprovalMoalInterface {}

const SkipApprovalModal: FC<SkipApprovalMoalInterface> = () => {
  const dispatch = useDispatch()
  const {
    postId,
    project,
    postSocials,
    isSkipApprovalModalOpen,
    inProgress,
    inProgressPost,
    skippedApprovals,
    selectedPostSocialId,
    postSocialsApprovalPlan,
  } = useSelector((state) => ({
    postId: state.managePost.post.id,
    inProgressPost: state.managePost.loaders.post.save,
    project: state.project.currentProject,
    postSocials: state.managePost.postSocials,
    isSkipApprovalModalOpen: state.skipApproval.is_skip_approval_modal_open,
    inProgress: state.skipApproval.inProgress,
    skippedApprovals: state.skipApproval.skipped_approvals,
    selectedPostSocialId: state.managePost.selectedPostSocialId,
    postSocialsApprovalPlan: state.managePost.approval.post_socials,
  }))
  const [checkboxValue, setCheckboxValue] = useState<Array<string>>([])

  useEffect(() => {
    setCheckboxValue(skippedApprovals)
  }, [skippedApprovals])

  useEffect(() => {
      dispatch(getProjectUsersByRoleThunk())
  }, [])

  const isExistRevisionsPostSocial: boolean = useMemo(() => {
    const postSocial = postSocials.find(({ id }) => id === selectedPostSocialId)!
    if (postSocial) {
      return postSocial?.status === POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION
    }
    return false
  }, [selectedPostSocialId, postSocials])

  const onSubmit = async () => {
    if (checkboxValue.length > 0) {
      if (
        (checkboxValue.includes(APPROVAL_TYPE.TYPE_INTERNAL) &&
        checkboxValue.includes(APPROVAL_TYPE.TYPE_EXTERNAL)) || (approversList.length === 0)
      ) {
        let result
        if (!postId) {
          result = await savePostAsDraft()
        } else {
          result = await dispatch(updatePostSocialsThunk())
        }
        if (isFulfilled(result)) {
            let response;
            if(isExistRevisionsPostSocial){
              const masterContentSocial = postSocialsApprovalPlan.find(
                (socialPlan) => socialPlan.is_master_content
              )    
              const payload = {
                post_social_id: masterContentSocial?masterContentSocial.id:selectedPostSocialId,
                skipped_approvals: checkboxValue
              }
              response = await dispatch(skipApprovalPostsSocialThunk(payload))
            }else{
              const payload = {
                post_id: postId === 0 ? result.payload.id : postId,
                skipped_approvals: checkboxValue
              }
              response = await dispatch(skipApprovalPostsThunk(payload))
            }
          
          if (isFulfilled(response)) {
            const { post_socials, post_status } = response.payload.data
            await dispatch(updateSkipApprovalAction({ post_status, post_socials }))
            await dispatch(toggleIsSkipAprrovalModalAction())
            await dispatch(resetSkipApprovalAction())
          }
        }
      } else {
        
        await dispatch(toggleIsSkipAprrovalModalAction())
        await dispatch(updateSkipApproverAction(checkboxValue))
        dispatch(openApproverModalAction(true))
      }
    }

   
    // let result
    // if (!postId) {
    //   result = await savePostAsDraft()
    // } else {
    //   result = await dispatch(updatePostSocialsThunk())
    // }
    // if (isFulfilled(result)) {
    //   const payload = {
    //     post_id: postId === 0 ? result.payload.id : postId,
    //     skipped_approvals: checkboxValue
    //   }
    //   const response = await dispatch(skipApprovalPostsThunk(payload))
    //   if (isFulfilled(response)) {
    //   if (
    //     checkboxValue.includes(APPROVAL_TYPE.TYPE_INTERNAL) &&
    //     checkboxValue.includes(APPROVAL_TYPE.TYPE_EXTERNAL)
    //   ) {
    //     const { post_socials, post_status } = response.payload.data
    //     dispatch(updateSkipApprovalAction({ post_status, post_socials }))
    //     dispatch(toggleIsSkipAprrovalModalAction())
    //     dispatch(resetSkipApprovalAction())
    //   } else {
    //     dispatch(toggleIsSkipAprrovalModalAction())
    //     dispatch(openApproverModalAction(true))
    //     dispatch(openApproverModalAction(false))
    //     // dispatch(toggleIsOpenAprrovalModalAction())
    //   }

    //   }
    // }
  }

  const approversList = useMemo(() => project.projectUsers.filter(
          ({ role ,setting}) =>
          (role === Roles.EXTERNAL_APPROVER ) 
        ),[project.projectUsers])

  const savePostAsDraft = async () => {
    const savePostResponse = await dispatch(savePostAsDraftAndScheduleThunk())
    if (isFulfilled(savePostResponse)) {
      await dispatch(
        push(
          generatePath(AUTH_ROUTE.MANAGE_POST, {
            projectId: project.id,
            social: postSocials[0].social_network
          }) + `?postId=${savePostResponse.payload.id}`
        )
      )
    }
    return savePostResponse
  }

  const handleChange = (checked: boolean, type: string) => {
    const value = [...checkboxValue]
    if (checked) {
      value.push(type)
    } else {
      const index = value.indexOf(type)
      if (index > -1) {
        value.splice(index, 1)
      }
    }
    setCheckboxValue(value)
  }

  const close = () => {
    dispatch(resetSkipApprovalAction())
    dispatch(toggleIsSkipAprrovalModalAction())
  }

  return (
    <>
      <CustomPopup
        open={isSkipApprovalModalOpen}
        // buttonClose={closeInviteApprovalModal}
        closeOnDocumentClick={false}
        className='skip-to-approval'
      >
        <div className='skip-to-approval__wrapper'>
          <div className='skip-to-approval__title'>Skip Approval</div>
          <p className='skip-to-approval__subtext'>Select which approvers to skip</p>
          <div className='skip-to-approval__list'>
            <div className='skip-to-approval__input'>
              <div className='skip-to-approval__checklist'>
                <Checkbox
                  label={'Internal approvers'}
                  name={APPROVAL_TYPE.TYPE_INTERNAL}
                  checked={checkboxValue.includes(APPROVAL_TYPE.TYPE_INTERNAL)}
                  onClick={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange(checked, APPROVAL_TYPE.TYPE_INTERNAL)
                  }
                />
              </div>
            </div>
            {approversList.length > 0? <div className='skip-to-approval__input'>
              <div className='skip-to-approval__checklist'>
                <Checkbox
                  label={'External approvers'}
                  name={APPROVAL_TYPE.TYPE_EXTERNAL}
                  checked={checkboxValue.includes(APPROVAL_TYPE.TYPE_EXTERNAL)}
                  onClick={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange(checked, APPROVAL_TYPE.TYPE_EXTERNAL)
                  }
                />
              </div>
            </div>:null}
            <div className='skip-to-approval__actions'>
              <CustomButton onClick={close} type='button' button='secondary'>
                Cancel
              </CustomButton>
              <CustomButton
                disabled={checkboxValue.length === 0}
                inProgress={inProgress || inProgressPost}
                button='primary'
                type='button'
                onClick={onSubmit}
              >
                Skip and Schedule
              </CustomButton>
            </div>
          </div>
        </div>
      </CustomPopup>
    </>
  )
}

export default SkipApprovalModal
